import { useDispatch } from "react-redux";
import { ChatDispatch } from "../store/actions/types";

export const useChatDispatch = () => useDispatch<ChatDispatch>();
